const dark = {
	"theme.background.primary": "{base.neutral.100}",
  "theme.background.secondary": "{base.neutral.90}",
  "theme.background.tertiary": "{base.neutral.80}",
  "theme.background.quaternary": "{base.neutral.60}",
  "theme.background.badge": "{base.secondary.100}",
  "theme.background.debug": "{base.tertiary.90}",
  "theme.background.danger": "{base.red.20}",
  "theme.background.warning": "{base.orange.20}",
  "theme.background.success": "{base.green.20}",
  "theme.background.info": "{base.secondary.20}",
  "theme.background.interactive.base": "{base.primary.90}66",
	"theme.background.interactive.hover": "{base.primary.90}99",
	"theme.background.interactive.secondary.base": "{base.secondary.90}66",
	"theme.background.interactive.secondary.hover": "{base.secondary.90}99",
	"theme.background.interactive.tertiary.base": "{base.tertiary.90}66",
  "theme.background.interactive.tertiary.hover": "{base.tertiary.90}99",
  "theme.background.drop": "{theme.background.selection.secondary.active}",
  "theme.background.selection.primary.active": "{base.primary.20}66",
  "theme.background.selection.primary.inactive": "{base.primary.20}44",
  "theme.background.selection.secondary.active": "{base.secondary.20}66",
  "theme.background.selection.secondary.inactive": "{base.secondary.20}44",
  "theme.background.selection.tertiary.active": "{base.tertiary.20}66",
  "theme.background.selection.tertiary.inactive": "{base.tertiary.20}44",
  "theme.background.highlight.primary.active": "{base.yellow.20}66",
  "theme.background.highlight.primary.inactive": "{base.yellow.20}44",
  "theme.background.highlight.secondary.active": "{base.blue.20}66",
  "theme.background.highlight.secondary.inactive": "{base.blue.20}44",
  "theme.border.primary": "{base.neutral.0}66",
  "theme.border.secondary": "{base.neutral.0}44",
  "theme.border.tertiary": "{base.neutral.0}22",
  "theme.border.active": "{base.primary.20}CC",
  "theme.border.success": "{base.green.20}CC",
  "theme.border.danger": "{base.red.20}CC",
  "theme.border.warning": "{base.orange.20}CC",
  "theme.border.info": "{base.secondary.20}CC",
  "theme.font.primary": "{base.neutral.0}",
  "theme.font.secondary": "{base.neutral.5}",
  "theme.font.tertiary": "{base.neutral.10}",
  "theme.font.quaternary": "{base.neutral.20}",
  "theme.font.ghost": "{base.neutral.40}",
  "theme.font.inverse": "{theme.background.primary}",
  "theme.font.active": "{base.primary.20}",
  "theme.font.success": "{base.green.20}",
  "theme.font.danger": "{base.red.20}",
  "theme.font.warning": "{base.orange.20}",
  "theme.font.info": "{base.secondary.20}",
  "theme.font.link.primary.active": "{base.secondary.20}",
  "theme.font.link.primary.inactive": "{base.secondary.20}CC",
  "theme.font.link.secondary.active": "{base.primary.20}",
  "theme.font.link.secondary.inactive": "{base.primary.20}CC",
  "theme.font.code.1": "{base.red.10}",
  "theme.font.code.2": "{base.orange.10}",
  "theme.font.code.3": "{base.yellow.10}",
  "theme.font.code.4": "{base.lime.10}",
  "theme.font.code.5": "{base.green.10}",
  "theme.font.code.6": "{base.teal.10}",
  "theme.font.code.7": "{base.blue.10}",
  "theme.font.code.8": "{base.purple.10}",
  "theme.font.code.9": "{base.pink.10}",
  "theme.font.code.21": "{base.red.20}",
  "theme.font.code.22": "{base.orange.20}",
  "theme.font.code.23": "{base.yellow.20}",
  "theme.font.code.24": "{base.lime.20}",
  "theme.font.code.25": "{base.green.20}",
  "theme.font.code.26": "{base.teal.20}",
  "theme.font.code.27": "{base.blue.20}",
  "theme.font.code.28": "{base.purple.20}",
	"theme.font.code.29": "{base.pink.20}",
	"theme.font.red.transparent": "{base.red.20}44",
	"theme.font.orange.transparent": "{base.orange.20}44",
	"theme.font.yellow.transparent": "{base.yellow.20}44",
	"theme.font.lime.transparent": "{base.lime.20}44",
	"theme.font.green.transparent": "{base.green.20}44",
	"theme.font.teal.transparent": "{base.teal.20}44",
	"theme.font.blue.transparent": "{base.blue.20}44",
	"theme.font.purple.transparent": "{base.purple.20}44",
	"theme.font.pink.transparent": "{base.pink.20}44",
}

const light = {
  "theme.background.primary": "{base.neutral.0}",
  "theme.background.secondary": "{base.neutral.5}",
  "theme.background.tertiary": "{base.neutral.10}",
  "theme.background.quaternary": "{base.neutral.20}",
  "theme.background.badge": "{base.secondary.20}",
  "theme.background.debug": "{base.tertiary.20}",
  "theme.background.danger": "{base.red.100}",
  "theme.background.warning": "{base.orange.100}",
  "theme.background.success": "{base.green.100}",
  "theme.background.info": "{base.secondary.100}",
  "theme.background.interactive.base": "{base.primary.20}66",
	"theme.background.interactive.hover": "{base.primary.20}99",
	"theme.background.interactive.secondary.base": "{base.secondary.20}66",
	"theme.background.interactive.secondary.hover": "{base.secondary.20}99",
	"theme.background.interactive.tertiary.base": "{base.tertiary.20}66",
  "theme.background.interactive.tertiary.hover": "{base.tertiary.20}99",
  "theme.background.drop": "{theme.background.selection.secondary.active}",
  "theme.background.selection.primary.active": "{base.primary.90}66",
  "theme.background.selection.primary.inactive": "{base.primary.90}44",
  "theme.background.selection.secondary.active": "{base.secondary.90}66",
  "theme.background.selection.secondary.inactive": "{base.secondary.90}44",
  "theme.background.selection.tertiary.active": "{base.tertiary.90}66",
  "theme.background.selection.tertiary.inactive": "{base.tertiary.90}44",
  "theme.background.highlight.primary.active": "{base.yellow.90}66",
  "theme.background.highlight.primary.inactive": "{base.yellow.90}44",
  "theme.background.highlight.secondary.active": "{base.blue.90}66",
  "theme.background.highlight.secondary.inactive": "{base.blue.90}44",
  "theme.border.primary": "{base.neutral.100}99",
  "theme.border.secondary": "{base.neutral.100}33",
  "theme.border.tertiary": "{base.neutral.100}11",
  "theme.border.active": "{base.primary.90}CC",
  "theme.border.success": "{base.green.90}CC",
  "theme.border.danger": "{base.red.90}CC",
  "theme.border.warning": "{base.orange.90}CC",
  "theme.border.info": "{base.secondary.90}CC",
  "theme.font.primary": "{base.neutral.100}",
  "theme.font.secondary": "{base.neutral.90}",
  "theme.font.tertiary": "{base.neutral.80}",
  "theme.font.quaternary": "{base.neutral.60}",
  "theme.font.ghost": "{base.neutral.40}",
  "theme.font.inverse": "{theme.background.primary}",
  "theme.font.active": "{base.primary.100}",
  "theme.font.success": "{base.green.100}",
  "theme.font.danger": "{base.red.100}",
  "theme.font.warning": "{base.orange.100}",
  "theme.font.info": "{base.secondary.100}",
  "theme.font.link.primary.active": "{base.secondary.100}",
  "theme.font.link.primary.inactive": "{base.secondary.100}CC",
  "theme.font.link.secondary.active": "{base.primary.100}",
  "theme.font.link.secondary.inactive": "{base.primary.100}CC",
  "theme.font.code.1": "{base.red.90}",
  "theme.font.code.2": "{base.orange.90}",
  "theme.font.code.3": "{base.yellow.90}",
  "theme.font.code.4": "{base.lime.90}",
  "theme.font.code.5": "{base.green.90}",
  "theme.font.code.6": "{base.secondary.90}",
  "theme.font.code.7": "{base.blue.90}",
  "theme.font.code.8": "{base.tertiary.90}",
  "theme.font.code.9": "{base.primary.90}",
  "theme.font.code.21": "{base.red.100}",
  "theme.font.code.22": "{base.orange.100}",
  "theme.font.code.23": "{base.yellow.100}",
  "theme.font.code.24": "{base.lime.100}",
  "theme.font.code.25": "{base.green.100}",
  "theme.font.code.26": "{base.secondary.100}",
  "theme.font.code.27": "{base.blue.100}",
  "theme.font.code.28": "{base.tertiary.100}",
	"theme.font.code.29": "{base.primary.100}",
	"theme.font.red.transparent": "{base.red.100}44",
	"theme.font.orange.transparent": "{base.orange.100}44",
	"theme.font.yellow.transparent": "{base.yellow.100}44",
	"theme.font.lime.transparent": "{base.lime.100}44",
	"theme.font.green.transparent": "{base.green.100}44",
	"theme.font.teal.transparent": "{base.teal.100}44",
	"theme.font.blue.transparent": "{base.blue.100}44",
	"theme.font.purple.transparent": "{base.purple.100}44",
	"theme.font.pink.transparent": "{base.pink.100}44",
}

const hc = dark;

export {dark, light, hc}
